var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedinNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16734_191909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 0.765625H2.3625C1.05625 0.765625 0 1.79688 0 3.07188V30.4531C0 31.7281 1.05625 32.7656 2.3625 32.7656H29.6313C30.9375 32.7656 32 31.7281 32 30.4594V3.07188C32 1.79688 30.9375 0.765625 29.6313 0.765625ZM9.49375 28.0344H4.74375V12.7594H9.49375V28.0344ZM7.11875 10.6781C5.59375 10.6781 4.3625 9.44687 4.3625 7.92812C4.3625 6.40938 5.59375 5.17812 7.11875 5.17812C8.6375 5.17812 9.86875 6.40938 9.86875 7.92812C9.86875 9.44063 8.6375 10.6781 7.11875 10.6781ZM27.2687 28.0344H22.525V20.6094C22.525 18.8406 22.4937 16.5594 20.0562 16.5594C17.5875 16.5594 17.2125 18.4906 17.2125 20.4844V28.0344H12.475V12.7594H17.025V14.8469H17.0875C17.7187 13.6469 19.2688 12.3781 21.575 12.3781C26.3813 12.3781 27.2687 15.5406 27.2687 19.6531V28.0344V28.0344Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16734_191909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin-nav.8c01856d.svg";
export { ForwardRef as ReactComponent };